import APIError from '../errors/APIError';
import { IParameter } from '../models/Parameter';

import HttpClient from './utils/HttpClient';

type ShowParameterResponse = Pick<
  IParameter,
  'id' | 'description' | 'role' | 'active'
>;

class ParametersService {
  private httpClient = HttpClient;

  public async showParameter(
    decription: string,
    companyId: number,
  ): Promise<ShowParameterResponse> {
    try {
      const response = await this.httpClient.get(
        `companies/${companyId}/parameters?description=${decription}`,
      );

      return response.data;
    } catch (error) {
      let errorMessage = '';

      if (error instanceof Error) {
        errorMessage = error.message;
      }

      throw new APIError(errorMessage);
    }
  }
}

export default new ParametersService();
